































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import DateField from "@/components/misc/DateField.vue";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { PaymentMean } from "@/shared/models/paymentMean";
import { CardType } from "@/shared/models/cardType";
import {
  DistributionChannelEnum,
  PaymentMeansEnum,
  TenantTypesEnum,
} from "@/shared/models/enums.type";
import { Notification } from "../../../store/modules/notifications";
import { DataOptions } from "vuetify";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { SortableTableHeader } from "../../generic-pms-table/SortableTableDirective";
import VReservation from "@/shared/models/vReservation";
import { ListModel } from "@/shared/models/listModel";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import TableCellUnitTypeDisplay from "@/components/misc/TableCellUnitTypeDisplay.vue";
import { reservationStatuses } from "@/shared/models/vReservation";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { InvoiceAutogenerationModel } from "./types";
import { ReservationListViewModel } from "@/shared/models/reservationListViewModel";
import GenericPMSTableSelectionBucket from "@/components/generic-pms-table/GenericPMSTableSelectionBucket.vue";
import { differenceInDays } from "@/shared/dateFormatUtils";
import { FinancialSettingsType } from "@/store/modules/financial";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import * as _ from "lodash";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { DistributionChannelTypesEnum } from "@/components/reservation-form/types";

@Component({
  components: {
    DateField,
    SortableHeadersTable,
    TableCellUnitTypeDisplay,
    GenericPMSTableSelectionBucket,
    LoadingOverlay,
  },
})
export default class BulkInvoiceGenerationModal extends Vue {
  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;

  tagSeparator = "\r\n";

  @PropSync("open", { default: false }) isOpen?: boolean;
  closeModal() {
    this.clearGrid();
    this.$emit("reload");
    this.isOpen = false;
  }

  @Watch("isOpen")
  isOpenWatch(fresh: boolean, old: boolean) {
    if (this.initLoaded && fresh && !old) {
      this.load();
    }
  }

  clearGrid() {
    this.filters = {
      reservationId: null as number | null,
      arrivalOrDepartureDate: "",
      bookingDate: "",
      arrivalDateFromPeriod: "",
      arrivalDateToPeriod: "",
      departureDateFromPeriod: "",
      departureDateToPeriod: "",
      reservationHolderName: "",
      otachannelName: "",
      distributionChannelTypeId: null as number | null,
      statusIds: [],
    };
    this.selected = [];
  }

  clearSelectionFilters() {
    this.selectionFilters = {
      reservationId: null as number | null,
      arrivalOrDepartureDate: "",
      bookingDate: "",
      arrivalDateFromPeriod: "",
      arrivalDateToPeriod: "",
      departureDateFromPeriod: "",
      departureDateToPeriod: "",
      reservationHolderName: "",
      otachannelName: "",
      distributionChannelTypeId: null as number | null,
      statusIds: [],
    };
  }

  async created() {
    const promises = [];

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    if (!this.storedSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);

    if (this.storedSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.storedSettings
      );
    }
  }

  getRowClass(item: VReservation) {
    let classes = "";
    if (
      item.distributionChannelTypeId ===
      DistributionChannelEnum.OwnersReservation
    ) {
      classes = "row-highlighted";
    }
    return classes;
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  differenceInDays = differenceInDays;

  settingsOpen = false;
  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["period"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  selectionFilters = {
    reservationId: null as number | null,
    arrivalOrDepartureDate: "",
    bookingDate: "",
    arrivalDateFromPeriod: "",
    arrivalDateToPeriod: "",
    departureDateFromPeriod: "",
    departureDateToPeriod: "",
    reservationHolderName: "",
    otachannelName: "",
    distributionChannelTypeId: null as number | null,
    statusIds: [] as number[]
  };

  selectionFilterFunction(
    selectedItems: ReservationListViewModel[],
    selectionFilter: typeof BulkInvoiceGenerationModal.prototype.selectionFilters
  ) {
    let toReturn = selectedItems;

    if (selectionFilter.reservationId) {
      toReturn = toReturn.filter(
        (x) => x.reservationId === selectionFilter.reservationId
      );
    }

    if (selectionFilter.arrivalOrDepartureDate) {
      toReturn = toReturn.filter(
        (x) =>
          x.arrivalDate.substring(0, 10) ===
            selectionFilter.arrivalOrDepartureDate ||
          x.departureDate.substring(0, 10) ===
            selectionFilter.arrivalOrDepartureDate
      );
    }

    if (selectionFilter.bookingDate) {
      toReturn = toReturn.filter(
        (x) => x.bookingDate.substring(0, 10) === selectionFilter.bookingDate
      );
    }

    if (selectionFilter.arrivalDateFromPeriod) {
      if (selectionFilter.arrivalDateToPeriod) {
        toReturn = toReturn.filter(
          (x) =>
            x.arrivalDate.substring(0, 10) >=
              selectionFilter.arrivalDateFromPeriod &&
            x.arrivalDate.substring(0, 10) <=
              selectionFilter.arrivalDateToPeriod
        );
      } else {
        toReturn = toReturn.filter(
          (x) =>
            x.arrivalDate.substring(0, 10) ===
            selectionFilter.arrivalDateFromPeriod
        );
      }
    }

    if (selectionFilter.departureDateFromPeriod) {
      if (selectionFilter.departureDateToPeriod) {
        toReturn = toReturn.filter(
          (x) =>
            x.departureDate.substring(0, 10) >=
              selectionFilter.departureDateFromPeriod &&
            x.departureDate.substring(0, 10) <=
              selectionFilter.departureDateToPeriod
        );
      } else {
        toReturn = toReturn.filter(
          (x) =>
            x.departureDate.substring(0, 10) ===
            selectionFilter.departureDateFromPeriod
        );
      }
    }

    if (selectionFilter.reservationHolderName) {
      toReturn = toReturn.filter((x) =>
        x.reservationHolderName
          .toLowerCase()
          .includes(selectionFilter.reservationHolderName.toLowerCase())
      );
    }

    if (selectionFilter.otachannelName) {
      toReturn = toReturn.filter((x) =>
        x.otachannelName
          .toLocaleLowerCase()
          .includes(selectionFilter.otachannelName.toLowerCase())
      );
    }

    if (selectionFilter.distributionChannelTypeId) {
      toReturn = toReturn.filter(
        (x) =>
          x.distributionChannelTypeId ===
          selectionFilter.distributionChannelTypeId
      );
    }

    if (selectionFilter.statusIds && selectionFilter.statusIds.length > 0) {
      toReturn = toReturn.filter(
        (x) => selectionFilter.statusIds.includes(x.statusId)
      );
    }

    return toReturn;
  }

  filters = {
    reservationId: null as number | null,
    arrivalOrDepartureDate: "",
    bookingDate: "",
    arrivalDateFromPeriod: "",
    arrivalDateToPeriod: "",
    departureDateFromPeriod: "",
    departureDateToPeriod: "",
    reservationHolderName: "",
    otachannelName: "",
    distributionChannelTypeId: null as number | null,
    statusIds: [] as number[]
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  list: ListModel<ReservationListViewModel> = {
    count: 0,
    result: [],
  };

  currencyConversionService?: CurrencyConversionService;
  selected = [] as ReservationListViewModel[];

  get selectedForBucket() {
    return this.selected.map((x) => {
      return {
        ...x,
        period: x.arrivalDate,
      };
    });
  }

  get totalSelectedValueInWorkingCurrency() {
    return this.selected.reduce((sum, x) => {
      if (this.currencyConversionService && this.storedSettings) {
        return (
          sum +
          this.currencyConversionService.convertCurrency(
            x.totalPrice,
            x.currencyId,
            this.storedSettings.workingCurrency.id
          )
        );
      } else {
        return sum + x.totalPrice;
      }
    }, 0);
  }

  get bucketShortDescription() {
    const prefix = this.$t(
      "FinancialDocument.Autogeneration.TotalPrice"
    ).toString();

    const value = this.$n(this.totalSelectedValueInWorkingCurrency, {
      style: "currency",
      currency: this.storedSettings?.workingCurrency.isoCode ?? "EUR",
      currencyDisplay: "code",
    });

    return prefix + ": " + value;
  }

  loading = true;
  firstLoad = true;
  initialListSize = 0;

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<typeof BulkInvoiceGenerationModal.prototype.list> {
    this.loading = true;
    return this.axios
      .get<ListModel<ReservationListViewModel>>(
        "/reservations/GetReservationsForBulkInvoiceGeneration",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        this.list = {
          result: res.data.result,
          count: res.data.count,
        };
        if (this.firstLoad) {
          this.initialListSize = this.list.count ?? 0;
        }
        return this.list;
      })
      .finally(() => {
        this.firstLoad = false;
        this.scrollToTop();
        this.loading = false;
      });
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == "period"
          ? ["arrivalDate", "reservationId"]
          : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
      statusIds: this.filters.statusIds.length > 0 ? this.filters.statusIds.join(",") : null,  
    };
  }

  get statuses() {
    return reservationStatuses;
  }

  statusStyle(statusId: number) {
    return this.statuses.find((x) => x.id == statusId) ?? {};
  }

  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];

  distributionChannelName(value: number) {
    const name = this.distributionChannelTypes?.find(
      (x) => x.id == value
    )?.textResourceKey;
    return name ? this.$t(name) : "";
  }

  get availableCardTypes() {
    return this.cardTypes?.filter(c => !c.name.includes('- VCC')) ?? [];
  }

  get isTenantTypeAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get allowedDistributionChannelTypes() {
    if (!this.distributionChannelTypes) {
      return [];
    }
    const types = _.cloneDeep(this.distributionChannelTypes);

    if (this.isTenantTypeAgency) {
      return types;
    } else {
      return types?.filter(
        (channel) =>
          channel.id != DistributionChannelTypesEnum.OwnersReservation
      );
    }
  }

  get serviceArrivalPeriod() {
    const res = [
      this.filters.arrivalDateFromPeriod
        ? this.filters.arrivalDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.arrivalDateToPeriod
        ? this.filters.arrivalDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceArrivalPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.arrivalDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.arrivalDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.arrivalDateFromPeriod = "";
      this.filters.arrivalDateToPeriod = "";
    }
  }

  get serviceDeparturePeriod() {
    const res = [
      this.filters.departureDateFromPeriod
        ? this.filters.departureDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.departureDateToPeriod
        ? this.filters.departureDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceDeparturePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.departureDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.departureDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.departureDateFromPeriod = "";
      this.filters.departureDateToPeriod = "";
    }
  }

  // selection filter helpers
  get selectionArrivalPeriod() {
    const res = [
      this.selectionFilters.arrivalDateFromPeriod
        ? this.selectionFilters.arrivalDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.selectionFilters.arrivalDateToPeriod
        ? this.selectionFilters.arrivalDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set selectionArrivalPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.selectionFilters.arrivalDateFromPeriod =
        val.length > 0 ? val[0] : "";
      this.selectionFilters.arrivalDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.selectionFilters.arrivalDateFromPeriod = "";
      this.selectionFilters.arrivalDateToPeriod = "";
    }
  }

  get selectionDeparturePeriod() {
    const res = [
      this.selectionFilters.departureDateFromPeriod
        ? this.selectionFilters.departureDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.selectionFilters.departureDateToPeriod
        ? this.selectionFilters.departureDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set selectionDeparturePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.selectionFilters.departureDateFromPeriod =
        val.length > 0 ? val[0] : "";
      this.selectionFilters.departureDateToPeriod =
        val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.selectionFilters.departureDateFromPeriod = "";
      this.selectionFilters.departureDateToPeriod = "";
    }
  }

  headers: SortableTableHeader[] = [
    {
      text: "Period",
      value: "period",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Reservation.ArrivalDate",
      value: "arrivalDate",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Reservation.DepartureDate",
      value: "departureDate",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Reservation holder",
      value: "reservationHolderName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Reservation status",
      value: "statusId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Reservation Id",
      value: "reservationId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Total price",
      value: "totalPrice",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Booking date",
      value: "bookingDate",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Sales channel",
      value: "otachannelName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "DistributionChannel",
      value: "distributionChannelTypeId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [""],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
      align: "end",
    },
  ];

  // internal model
  internalModalOpen = false;

  model = {
    issueDate: new Date().toISOString().substring(0, 10),
    deliveryDate: new Date().toISOString().substring(0, 10),
    dueDate: new Date().toISOString().substring(0, 10),
    businessUnitId: null,
    cashRegisterId: null,
    showOwnerDetails: false,
    paymentMeansId: null,
    paymentMeanBaseId: null,
    cardTypeId: null,
    preferReservationPaymentMeans: false,
    advanceInvoicesCancellationBackupBusinessUnitId: null,
    advanceInvoicesCancellationBackupCashRegisterId: null,
  } as InvoiceAutogenerationModel;

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  // prettier-ignore
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];

  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;
  @Getter("cashRegister/availableCashRegisters")
  availableCashRegisters?: CashRegisterModel[];

  @Getter("businessUnit/allBusinessUnits") allBusinessUnits?: BusinessUnit[];
  @Getter("cashRegister/allCashRegisters")
  allCashRegisters?: CashRegisterModel[];
  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;

  get businessUnits() {
    return (
      this.allBusinessUnits?.filter(
        (x) => x.status && !x.isOwnerBusinessUnit
      ) ?? []
    );
  }

  get cashRegistersForBusinessUnitBackup() {
    return (
      this.allCashRegisters?.filter(
        (x) =>
          x.status &&
          x.businessUnitId ===
            this.model.advanceInvoicesCancellationBackupBusinessUnitId
      ) ?? []
    );
  }

  // prettier-ignore
  @Getter("appParams/automaticRelatedAdvanceInvoiceCancellingDefault") automaticRelatedAdvanceInvoiceCancellingDefault?: boolean;

  get cashRegistersForBusinessUnit() {
    return (
      this.availableCashRegisters?.filter(
        (x) => x.businessUnitId === this.model?.businessUnitId
      ) ?? []
    );
  }

  cardPaymentMeansIds = [
    PaymentMeansEnum.OnlineServisZaPlacanje,
    PaymentMeansEnum.KreditnaKartica,
    PaymentMeansEnum.BankovnaKartica,
  ];
  get isCard() {
    return this.cardPaymentMeansIds.some(
      (x) => x === this.model?.paymentMeansId ||
             x === this.model?.paymentMeanBaseId
    );
  }

  isBulkInvoiceGenerationFormValid = false;
  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      // prettier-ignore
      dueDateCannotBeLessThanIssueDate: (value: any) =>
        ( 
          value &&
          this.model &&
          this.model.dueDate &&
          this.model.issueDate &&
          !(this.model.dueDate.substr(0, 10) < this.model.issueDate.substr(0, 10))
        ) ||
        this.$t("Validation.FinancialDocuments.DueDateCannotBeBeforeIssueDate"),
      // prettier-ignore
      deliveryDateCannotBeGreaterThanIssueDateIfInvoice: (value: any) =>
        ( 
          value &&
          this.model &&
          this.model.deliveryDate &&
          this.model.issueDate &&
          !(this.model.issueDate.substr(0, 10) < this.model.deliveryDate.substr(0, 10))
        ) ||
        this.$t("Validation.FinancialDocuments.DeliveryDateCannotBeAfterIssueDate"),
    };
  }

  confirmGeneration() {
    const count = this.selected.length;
    const value = this.$n(this.totalSelectedValueInWorkingCurrency, {
      style: "currency",
      currency: this.storedSettings?.workingCurrency.isoCode ?? "EUR",
      currencyDisplay: "code",
    });

    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("FinancialDocument.Autogeneration.Confirmation", {
        count: count,
        value: value,
      }),
      timeout: 15000,
      actions: [
        {
          text: this.$t("Yes"),
          fun: () => {
            this.generate();
            return true;
          },
        },
        { text: this.$t("Cancel"), fun: () => true },
      ],
    } as Notification);
  }

  generatingInvoices = false;
  generate() {
    this.generatingInvoices = true;
    this.axios
      .post("FinancialDocuments/BulkCreateInvoiceForReservation/", {
        ...this.model,
        reservationIds: this.selected.map((x) => x.reservationId),
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t(
            "FinancialDocument.Autogeneration.AsyncGenerationStarted"
          ),
          timeout: 15000,
        } as Notification);
        this.internalModalOpen = false;
      })
      .finally(() => {
        this.generatingInvoices = false;
      });
  }

  openInternalModal() {
    if (!this.model.paymentMeansId) {
      this.model.paymentMeansId = this.storedSettings?.paymentMeansId ?? null;
    }

    if (!this.model.businessUnitId) {
      this.model.businessUnitId = this.activeBusinessUnit?.id ?? null;
    }
    if (this.cashRegisterFeature) {
      this.model.cashRegisterId = this.activeCashRegister?.id ?? null;
    }

    if (this.automaticRelatedAdvanceInvoiceCancellingDefault) {
      this.model.advanceInvoicesCancellationBackupBusinessUnitId =
        this.model.businessUnitId;
      this.model.advanceInvoicesCancellationBackupCashRegisterId =
        this.model.cashRegisterId;
    }

    this.internalModalOpen = true;
  }

  selectingAll = false;
  selectAllReservations(val: boolean) {
    this.selectingAll = true;
    this.axios
      .get<ReservationListViewModel[]>(
        "/reservations/GetAllReservationsForBulkInvoiceGeneration",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        if (val) {
          this.selected = [...res.data];
        } else {
          this.selected = this.selected.filter(
            (item) =>
              !res.data.some((x) => x.reservationId === item.reservationId)
          );
        }
      })
      .finally(() => {
        this.scrollToTop();
        this.selectingAll = false;
      });
  }

  //initialListSize will be the maximum size this table can be
  //so selected array should be compared only to that initial state
  //anything less that that can be considered as -> not all selected
  areAllReservationsSelected() {
    return (
      this.selected.length === this.initialListSize &&
      (this.list.count ?? 0) > 0
    );
  }

  @Watch("model.businessUnitId")
  businessUnitChanged(fresh: number, old: number) {
    if (
      fresh !== old &&
      old !== null &&
      this.model &&
      this.cashRegisterFeature
    ) {
      this.model.cashRegisterId = null;
    }
  }
}
